import React, { useEffect } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { CardTitle, Button } from '@cordata/buffet';

import {
  referenceAdminInstance as config,
} from '~/utils';

import ReferenceGeneralEventDetailsField from './ReferenceGeneralEventDetailsField';

const deburrObject = (o) => {
  const obj = {
    ...o,
    ...o.attributes,
    ...o.relationships,
  };

  delete obj.attributes;
  delete obj.relationships;
  delete obj.links;

  return obj;
};

const ReferenceGeneralEventDetailsFieldArray = () => {
  const { setFieldValue, values } = useFormikContext();

  useEffect(() => {
    if (values.id) {
      config
        .get('ReferenceGeneralEventDetail', { params: { sort: 'defaultSortOrder', generalEventUid: values.id } })
        .then(r => r.data.data.map(deburrObject))
        .then(r => r.map(d => ({
          ...d,
          generalEventDetailType: {
            value: d.generalEventDetailType,
            label: d.generalEventDetailType,
          },
        })))
        .then((r) => {
          setFieldValue('referenceGeneralEventDetails', r);
        });
    }
  }, []);

  return (
    <FieldArray name="referenceGeneralEventDetails">
      {helpers => (
        <>
          <CardTitle>Details</CardTitle>

          {values.referenceGeneralEventDetails &&
            values.referenceGeneralEventDetails.map((v, i) => (
              <fieldset
                key={v && v.id ? v.id : `new-referenceDataEventDetails-${i}`}
              >
                <ReferenceGeneralEventDetailsField
                  value={v}
                  setFieldValue={setFieldValue}
                  index={i}
                />

                <Button
                  size="sm"
                  outline
                  color="danger"
                  spear
                  type="button"
                  onClick={() => {
                    if (v.id) {
                      setFieldValue(`referenceGeneralEventDetails.${i}.isActive`, false);
                      setFieldValue(`referenceGeneralEventDetails.${i}.isRequired`, false);
                    } else {
                      helpers.remove(i);
                    }
                  }}
                  icon="minus"
                >
                  Remove detail
                </Button>
              </fieldset>
            ))}

          <Button
            size="sm"
            outline
            color="tertiary"
            spear
            type="button"
            onClick={() => helpers.push({
              isActive: true,
              defaultSortOrder: values.referenceGeneralEventDetails.length,
              generalEventDetailLabel: '',
              generalEventDetailName: '',
            })}
            icon="plus"
          >
            Add detail
          </Button>
        </>
      )}
    </FieldArray>
  );
};

export default ReferenceGeneralEventDetailsFieldArray;
